import React from 'react'

const NotFound = props => (
    <h1>Sivua ei löydy</h1>
)

export default NotFound


// WEBPACK FOOTER //
// ./src/NotFound.js